import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'fin-product-expand',
  templateUrl: 'product-expand.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductExpandComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() title: string;

  open = false;
  id: string;

  ngOnInit(): void {
    this.id = uuid();
  }
}
